var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { diffWords } from 'diff';
import { InsDel } from './InsDel';
/**
 * Render a diff between two strings inside a MUI Typography component.
 *
 * Shows a word-by-word diff based on the [diff](https://www.npmjs.com/package/diff) package.
 *
 * @see https://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.4.6927
 *
 * @example
 * import { Diff } from '@react-admin/ra-history';
 *
 * const StringDiff = () => (
 *   <Diff from="Hello world!" to="Hello brave new world" />
 * );
 * // <Typography variant="body2">
 * //   <span>Hello </span><ins>brave new </ins><span>world</span><del>!</del>
 * // </Typography>
 */
export var Diff = function (_a) {
    var _b = _a.from, from = _b === void 0 ? '' : _b, _c = _a.to, to = _c === void 0 ? '' : _c, rest = __rest(_a, ["from", "to"]);
    var diff = diffWords(from, to);
    return (_jsx(Typography, __assign({ variant: "body2", component: "span" }, rest, { children: _jsx(InsDel, { children: diff.map(function (part, key) {
                if (part.added) {
                    return _jsx("ins", { children: part.value }, key);
                }
                if (part.removed) {
                    return _jsx("del", { children: part.value }, key);
                }
                return _jsx("span", { children: part.value }, key);
            }) }) })));
};
